<template>
  <div>
    <div class="columns mb-0">
      <div class="column">
        <kst-input floating-label
          field="Barcode" ref="txtBarcode" :data="searchData" :catalog="Catalog"
          @submit="handleEnter"
        />
      </div>
      <div class="column is-4">
        <kst-input floating-label
          field="Qty" ref="txtQty" :data="searchData" :catalog="Catalog"
          @submit="handleEnter"
        />
      </div>
    </div>

   <div class="list-pos-items">
      <div class="columns is-multiline">
        <div class="column is-half" v-for="(item, index) in items" :key="item.DispatchID">
          <div class="card-pos-item" v-on:click="handleItem_Click(item, index)">
            <div class="card-info">
              <kst-tooltip info-mode size="is-small" :position="getPosition(index)">
                <template #content>
                  <kst-list info-mode :items="Model.getItemInfo(item)"/>
                </template>
                <kst-icon info-mode/>
              </kst-tooltip>
            </div>

            <template v-if="item.SpecialPriceName !== undefined">
              <div class="ribbon-wrapper-red">
                <div class="ribbon-red">
                  <kst-value field="SpecialPriceName" :data="item" :catalog="ItemCatalog" />
                </div>
              </div>
            </template>

            <kst-image hide-preview read-only thumbnail :src="item['ImageSrc']"/>
            <h5><kst-value field="FullName" :data="item" :catalog="ItemCatalog"/></h5>
            <div class="divider" />

            <template v-if="item.SpecialPriceName !== undefined">
              <div class="columns mb-0">
                <div class="column pr-0">
                  <div class="is-12">
                    {{ ItemCatalog.MaxQuantity.Label }}
                  </div>
                </div>
                <div class="column pl-0">
                  <div class="has-text-weight-semibold is-12">
                    <kst-value field="MaxQuantity" :data="item" :catalog="ItemCatalog"/>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="columns mb-0">
                <div class="column pr-0">
                  <div class="is-12">
                    {{ ItemCatalog.Stock.Label }}
                  </div>
                </div>
                <div class="column pl-0">
                  <div class="has-text-weight-semibold is-12">
                    <kst-value field="Stock" :data="item" :catalog="ItemCatalog"/>
                  </div>
                </div>
              </div>
            </template>
            
            <div class="columns">
              <div class="column pr-0">
                <div class="is-12">
                  {{ ItemCatalog.SellPrice.Label }}
                </div>
              </div>

              <template v-if="item.SpecialPrice > 0">
                <div class="column pl-0">
                  <div class="has-text-weight-semibold is-12 has-text-danger">
                    <kst-value field="SpecialPrice" :data="item" :catalog="ItemCatalog"/>
                  </div>
                  <div class="has-text-grey ks-text-line-through">
                    <kst-value class="is-size-7" field="SellPrice" :data="item" :catalog="ItemCatalog"/>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="column pl-0">
                  <div class="has-text-weight-semibold is-12">
                    <kst-value field="SellPrice" :data="item" :catalog="ItemCatalog"/>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchMixin from "@/mixins/SearchMixin.js";
import SnackbarMixin from "@/mixins/SnackbarMixin.js";
import Catalog from "./PosCatalog.js";
import Model from "./PosModel.js";
import ItemCatalog from "./PosItemCatalog.js";

export default {
  mixins: [SearchMixin, SnackbarMixin],
  props: {
    itemsScanner: Array,
    userData: Object,
    searchData: Object,
    userItems: Array,
    specialPriceItems: Array
  },
  data: () => ({
    Catalog: Catalog,
    ItemCatalog: ItemCatalog,
    items: [],
    Model: Model,
    // tabs
    activeTab: 0,
  }),
  mounted() {
    window.addEventListener(this.$kst.Key.KeyEvent, this.handleKeyDown);
    this.setFocusBarcode();
  },
  destroyed() {
    window.removeEventListener(this.$kst.Key.KeyEvent, this.handleKeyDown);
  },
  created() {
    this.initSearch(this.searchData, this.submit);
  },
  methods: {
    handleKeyDown(event) {
      switch(event[this.$kst.Key.KeyProp]) {
        case this.$kst.Key.Key.F1:
          this.setFocusBarcode();
          event.preventDefault();
          break;
        case this.$kst.Key.Key.F2:
          this.setFocusQuantity();
          event.preventDefault();
          break;
      }
    },
    setFocusQuantity() {
      this.activeTab = 0;
      this.$refs.txtQty.focus();
    },
    setFocusBarcode() {
      this.activeTab = 0;
      this.$refs.txtBarcode.focus();
    },
    handleInput() {
      this.handleSearch();
    },
    submit() {
      this.$emit(this.$kst.Enum.Event.Submit);
    },
    clearInput() {
      this.searchData.Qty = 1;
      this.searchData.Barcode = "";
    },
    showError(message) {
      this.notifyFormError('', message);
    },
    handleSnackbarClose() {
      this.setFocusBarcode();
    },
    validate() {
      const barcode = this.searchData.Barcode;

      if (barcode !== null) {
        const item = this.$kst.Array.searchItem(
          this.itemsScanner, 'Barcode', barcode, { insensitive: true }
        );
        
        if (!item) {
          return 'Barcode tidak sesuai';
        } else if (item.Stock <= 0) {
          return 'Stok ' + item.FullName + ' tidak tersedia'
        }
      }
      else {
        return 'Barcode tidak sesuai';
      }
    },
    handleEnter() {
      const error = this.validate();
      const barcode = this.searchData.Barcode;
      const warehouse = this.userData.WarehouseID;
      if (!barcode) {
        return;
      } 
      if (error) {
        this.showError(error);
        return;
      } else {
        this.items = [];
        const item = this.$kst.Array.searchItem(
          this.itemsScanner, 'Barcode', barcode, { insensitive: true }
        );
        const specialPrice = this.specialPriceItems.find(row => {
          return row.DispatchID == item.DispatchID && row.WarehouseID == warehouse
        })
        if(specialPrice) {
          const specialItem = Model.populateItemsWithSpecialPrice([item], this.specialPriceItems, this.userData);
          this.items = specialItem;
          return;
        }
        this.addItem(item);
        this.clearInput();
        this.setFocusBarcode();
      }
    },

    resetScanResult() {
      this.items = [];
    },

    addItem(data) {
      let itemIdx = this.userItems.findIndex(unit => unit.DispatchID === data.DispatchID);

      if (itemIdx !== -1) {
        let item = this.userItems[itemIdx];
        item.RequestedQuantity = item.RequestedQuantity + parseInt(this.searchData.Qty);
        Model.updateItem(item);
      }
      else {
        let item = Model.createItem();
        item.RequestedQuantity = parseInt(this.searchData.Qty);
        Model.setItemByData(item, data);
        Model.updateItem(item);
        this.userItems.push(item);
        itemIdx = this.userItems.length - 1;
      }

      Model.updateDetails(this.userData, this.userItems);

      return itemIdx;
    },

    handleItem_Click(item, index) {
      let userItemIndex = this.addItem(item);

      this.$nextTick(() => {
        this.$emit(this.$kst.Enum.Event.Input, this.$jquery(".card-pos-item").eq(index), userItemIndex);
      });
    },
    getPosition(index) {
      return (index % 2 === 0) ? "is-right" : "is-bottom";
    }
  }
}
</script>